import { ErrorStateType } from '@models';
import { accept as acceptRequest } from '@services/termsOfService';
import {
  ErrorActionTypes,
  REMOVE_ERROR,
  IInitialPayloadAction,
} from '@store/types';
import { reset as resetInitialPayload } from '@store/actions';

export const accept = (): any => {
  return (
    dispatch: (action: ErrorActionTypes | IInitialPayloadAction) => void
  ): any => {
    acceptRequest()
      .then(() => {
        dispatch({ type: REMOVE_ERROR, payload: ErrorStateType.InvalidTOS });
        dispatch(resetInitialPayload());
      })
      .catch(() => {});
  };
};
